import { inject, Service } from '@angular/core';
import { Actions, ofActionSuccessful } from '@ngxs/store';
import { Logout, SwitchCentralInstance } from '@portal-core/auth/services/auth-data.service';
import { ResettableService } from '@portal-core/general/services/resettable.service';

/**
 * Resets all resetabbles when the user logs out.
 * Listens to the Logout action from the auth data store to reset the resettables.
 */
@Service()
export class AuthResettablesEffect {
  private readonly actions$ = inject(Actions);
  private readonly resettableService = inject(ResettableService);

  constructor() {
    this.actions$.pipe(
      ofActionSuccessful(Logout)
    ).subscribe(() => {
      this.resettableService.getResettables().forEach(resettable => resettable.reset$());
    });

    this.actions$.pipe(
      ofActionSuccessful(SwitchCentralInstance)
    ).subscribe(() => {
      this.resettableService.getResettables().forEach(resettable => resettable.reset$());
    });
  }
}
